import type { TOC } from '@ember/component/template-only';
import { array } from '@ember/helper';
import { PrismLoadingBar } from '@mylighthouse/prism-ember';
import { or } from 'ember-truth-helpers';
import SettingsCostLandingPage from 'lumen/components/settings/cost/landing-page';
import type MarketSettingsCostController from 'lumen/controllers/market/settings/cost';
import type MarketSettingsCostRoute from 'lumen/routes/market/settings/cost';
import type { ModelFrom } from 'lumen/utils/routes';

interface MarketSettingsCostSignature {
  Args: {
    controller: MarketSettingsCostController;
    model: ModelFrom<MarketSettingsCostRoute>;
  };
}

const MarketSettingsCost: TOC<MarketSettingsCostSignature> = <template>
  {{#if @model.profiles.isRunning}}
    <PrismLoadingBar />
  {{/if}}

  <SettingsCostLandingPage
    @isError={{@model.profiles.last.isError}}
    @isLoading={{@model.profiles.isRunning}}
    @isReadOnly={{@controller.isReadOnly}}
    @profiles={{or @model.profiles.last.value (array)}}
  />
</template>;

export default MarketSettingsCost;
